import parse from 'html-react-parser'
// import bubble from '../../assets/new-ui/bubble.png'
export default function EconomyBubble(props) {
  const { img, imgMobile, text } = props

  return (
    <div className='economyBubble'>
      <img className='imgBubble' src={img} alt='economy part' />
      <img className='imgBubbleMobile' src={imgMobile} alt='economy part' />
      <div>{parse(text)}</div>
    </div>
  )
}